export default __webpack_public_path__ + "static/media/user_dashboard_6.554996c8.png";